import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=ef19ec06&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=js&"
export * from "./Block.vue?vue&type=script&lang=js&"
import style0 from "./Block.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Block.vue?vue&type=style&index=1&id=ef19ec06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef19ec06",
  null
  
)

export default component.exports